import PropTypes from 'prop-types'
import {
  Flex,
  Box,
  Button,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'

import {NextScreenHeader as ScreenHeader} from '~/react/components/ScreenHeader'
import withProviders from '~/react/contexts/withProviders'
import Alert from '~/react/components/Alert'
import {useNavigate} from 'react-router'
import {usePermissions} from '../../hooks/usePermissions'

import PartnersTab from './PartnersTab'
import ActivitiesTab from './ActivitiesTab'

const AlertMessage = () => {
  const {t} = useTranslation('points')
  const navigate = useNavigate()

  const goToRewardsDashboard = () => {
    navigate('/points')
  }

  return (
    <Flex justify="space-between" align="center" flexWrap="wrap" gap="xs">
      <Text textStyle="body-intro-medium">
        {t('points:redemptionPartnerScreen.onboardingIncompleteAlert.title')}
      </Text>
      <Button
        as="a"
        variant="secondary"
        bg="transparent"
        onClick={goToRewardsDashboard}
      >
        {t(
          'points:redemptionPartnerScreen.onboardingIncompleteAlert.callToAction',
        )}
      </Button>
    </Flex>
  )
}

const RedemptionPartnersScreen = ({currentSupplier}) => {
  i18next.loadNamespaces('points')
  const {t} = useTranslation()

  const {data: permissionsData, isLoading} = usePermissions()
  const {connectRedemptionPartner} = permissionsData || {}

  return (
    <Flex flex="auto" direction="column" gap="sm">
      <ScreenHeader text={t('points:redemptionPartnerScreen.title')} />
      {!isLoading && !connectRedemptionPartner && (
        <Alert
          status="warning"
          message={<AlertMessage />}
          iconAlignment={{base: 'start', sm: 'center'}}
          mb="sm"
          className="fs-unmask"
        />
      )}
      <Box
        borderRadius="lg"
        background="mld.neutral.0"
        flex="auto"
        py="md"
        px="md"
      >
        <Tabs isLazy variant="basic">
          <TabList>
            <Tab className="fs-unmask">
              {t('points:redemptionPartnerScreen.partnersTab')}
            </Tab>
            <Tab className="fs-unmask">
              {t('points:redemptionPartnerScreen.activitiesTab')}
            </Tab>
          </TabList>

          <TabPanels className="fs-unmask" pt="md">
            <TabPanel p="0">
              <PartnersTab currentSupplier={currentSupplier} />
            </TabPanel>

            <TabPanel p="0">
              <ActivitiesTab currentSupplier={currentSupplier} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Flex>
  )
}

RedemptionPartnersScreen.propTypes = {
  currentSupplier: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default withProviders(RedemptionPartnersScreen)
